import React from 'react';

const VisionTechHeader = () => {
  return (
    <div className="vision-tech-header-container">
      <div className="vision-tech-header-animation-wrapper">
        <div className="vision-tech-header-animation-content">
          <div className="vision-tech-header-animation-text vision-tech-header-animation-text-1">
            Transforming the Investment Landscape
          </div>
          
          <div className="vision-tech-header-animation-text vision-tech-header-animation-text-2">
            Leading Tesla Product Investments
          </div>
          
          <div className="vision-tech-header-animation-text vision-tech-header-animation-text-3">
            Building Trust & Innovation
          </div>
          
          <div className="vision-tech-header-animation-text vision-tech-header-animation-text-4">
            Powering the EV Revolution
          </div>
        </div>

        <div className="vision-tech-header-animation-highlight">
          VisionTech2030
        </div>
      </div>

      <style jsx>{`
        .vision-tech-header-container {
          background: linear-gradient(135deg, rgba(255, 223, 162, 0.2) 0%, rgba(255, 215, 0, 0.1) 100%);
          color: white;
          padding: 0.3rem;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }

        .vision-tech-header-animation-wrapper {
          text-align: center;
          max-width: 800px;
        }

        .vision-tech-header-animation-title {
          font-size: 3rem;
          margin-bottom: 1rem;
          background: linear-gradient(45deg, #00ff88, #00ccff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          animation: vision-tech-header-animation-glow 3s ease-in-out infinite;
        }

        .vision-tech-header-animation-content {
          position: relative;
          height: 30px;
          margin: 0.5rem 0;
        }

        .vision-tech-header-animation-text {
          position: absolute;
          width: 100%;
          text-align: center;
          font-size: 1.3rem;
          opacity: 0;
          transform: translateY(20px);
          animation: vision-tech-header-animation-slide 12s infinite;
        }

        .vision-tech-header-animation-text-1 { animation-delay: 0s; }
        .vision-tech-header-animation-text-2 { animation-delay: 3s; }
        .vision-tech-header-animation-text-3 { animation-delay: 6s; }
        .vision-tech-header-animation-text-4 { animation-delay: 9s; }

        .vision-tech-header-animation-highlight {
          font-size: 2rem;
          font-weight: bold;
          margin-top: 2rem;
          color: #00ff88;
          text-shadow: 0 0 10px rgba(0, 255, 136, 0.5);
          animation: vision-tech-header-animation-pulse 2s ease-in-out infinite;
        }

        @keyframes vision-tech-header-animation-glow {
          0% { text-shadow: 0 0 10px rgba(0, 255, 136, 0.5); }
          50% { text-shadow: 0 0 20px rgba(0, 204, 255, 0.8); }
          100% { text-shadow: 0 0 10px rgba(0, 255, 136, 0.5); }
        }

        @keyframes vision-tech-header-animation-slide {
          0%, 5% { opacity: 0; transform: translateY(20px); }
          10%, 20% { opacity: 1; transform: translateY(0); }
          25%, 100% { opacity: 0; transform: translateY(-20px); }
        }

        @keyframes vision-tech-header-animation-pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.05); }
          100% { transform: scale(1); }
        }

        @media (max-width: 768px) {
          .vision-tech-header-animation-title {
            font-size: 2rem;
          }

          .vision-tech-header-animation-text {
            font-size: 1.2rem;
          }

          .vision-tech-header-animation-highlight {
            font-size: 1.5rem;
          }
        }

        @media (max-width: 480px) {
          .vision-tech-header-animation-title {
            font-size: 1.5rem;
          }

          .vision-tech-header-animation-text {
            font-size: 1rem;
          }

          .vision-tech-header-animation-highlight {
            font-size: 1.2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default VisionTechHeader;
